export default __webpack_public_path__ + "static/media/usa.f5d332fa.svg";